module.exports = __webpack_public_path__ + "img/windows1.fafd5ef6.png";